import { API } from '@/lib/catalog';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// Widths the backend resizer accepts (backend/image_service.py ALLOWED_WIDTHS)
export const CARD_WIDTHS = [400, 800, 1200];

// Sources /api/img can resize: seed images, admin uploads, supplier CDN URLs.
export const canOptimize = (src) =>
  typeof src === 'string' && (src.startsWith('/products/') || src.startsWith('/api/images/') || /^https?:\/\//.test(src));

// The untouched image, for the <img> fallback
export const originalUrl = (src) => (src && src.startsWith('/api/') ? `${BACKEND_URL}${src}` : src);

export const resizedUrl = (src, width, format) =>
  `${API}/img?src=${encodeURIComponent(src)}&w=${width}&f=${format}`;

const srcSet = (src, widths, format) => widths.map((w) => `${resizedUrl(src, w, format)} ${w}w`).join(', ');

/**
 * Responsive product photo: AVIF and WebP renditions via <picture>, the
 * original as fallback. `priority` = above the fold (eager + high priority);
 * everything else lazy-loads. Style the <img> through `className`.
 */
export const ProductImage = ({
  src,
  alt = '',
  sizes = '100vw',
  widths = CARD_WIDTHS,
  priority = false,
  className = '',
  width,
  height,
  ...rest
}) => {
  const img = (
    <img
      src={originalUrl(src)}
      alt={alt}
      width={width}
      height={height}
      loading={priority ? 'eager' : 'lazy'}
      fetchPriority={priority ? 'high' : undefined}
      decoding="async"
      className={className}
      {...rest}
    />
  );
  if (!canOptimize(src)) return img;
  return (
    <picture className="contents">
      <source type="image/avif" srcSet={srcSet(src, widths, 'avif')} sizes={sizes} />
      <source type="image/webp" srcSet={srcSet(src, widths, 'webp')} sizes={sizes} />
      {img}
    </picture>
  );
};
